

"use client";

export default function LocationIcon({ className = "", ...props }) {
    return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}
            {...props}>
<path d="M19.6882 10.6651C22.28 10.6651 24.3875 12.7725 24.3875 15.3644C24.3875 17.9562 22.28 20.0637 19.6882 20.0637C17.0963 20.0637 14.9888 17.9562 14.9888 15.3644C14.9888 12.7725 17.0963 10.6651 19.6882 10.6651ZM19.6882 7.97775C15.6083 7.97775 12.3015 11.2845 12.3015 15.3644C12.3015 19.4443 15.6083 22.751 19.6882 22.751C23.768 22.751 27.0748 19.4443 27.0748 15.3644C27.0748 11.2845 23.768 7.97775 19.6882 7.97775Z" fill="currentColor"/>
<path d="M19.6881 4.68732C25.7544 4.68732 30.6912 9.62417 30.6912 15.6904C30.6912 18.2171 28.8236 22.6789 25.6985 27.625C23.2021 31.5745 20.906 34.2851 19.6672 35.4774C18.4306 34.2968 16.1345 31.5978 13.6428 27.6343C10.5386 22.6975 8.68267 18.231 8.68267 15.6881C8.68267 9.62184 13.6195 4.68499 19.6858 4.68499M19.6881 2C12.1268 2 6 8.12914 6 15.6904C6 23.2517 17.3547 38.6375 19.6881 38.6375C22.0215 38.6375 33.3785 23.2517 33.3785 15.6904C33.3785 8.12914 27.2494 2 19.6881 2Z" fill="currentColor"/>
</svg>

    );
}